import React,{useState,useEffect,useRef} from 'react'
import {useParams,useNavigate} from 'react-router-dom'
import EmailEditor, {  EmailEditorProps } from 'react-email-editor';
import templateService from '../../../services/template.service';
import {toast} from 'react-toastify'

function ClinicEditEmailTemplate() {
    const {clinicId,templateId} = useParams()
    const [templateTypes,setTemplateTypes] = useState([])
    const emailEditorRef = useRef(null);
    const [txtType, setTxtType] = useState("PREBOOKED_REMINDER");
    const [txtUsedBy, settxtUsedBy] = useState("CLINIC");
    const [txtSubject, setTxtSubject] = useState(null);
    const [jsonString,setJsonString] = useState(null);
    const navigate = useNavigate()

    const handletxtTypeChange = (event) => {
        setTxtType(event.target.value);
      };
     const handletxtUsedByChange = (event) => {
        settxtUsedBy(event.target.value);
      };
      const handleTextChange = (event) => {
        setTxtSubject(event.target.value);
      };

    const exportHtml = () => {
        emailEditorRef.current.editor.exportHtml((data) => {
          const { design, html } = data;
          const jsonString = JSON.stringify(design)
          const edata = {
            id:templateId,
            clinicId:clinicId,
            type: txtType,
            mediumType: "EMAIL",
            subjectLine : txtSubject,
            content: html,
            jsonContent : jsonString,
            usedBy: txtUsedBy,
            status:1,
          }
          //call api to save 
          templateService.updateEmailTemplate(clinicId,templateId,edata)
          .then((res)=>{
            toast.success("Template Saved", {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
             
          })
          .catch((err) => {
            toast.error("Cannot Save Template.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            console.log(err);
          });
        });
      };
    
      const onLoad = () => {
        // editor instance is created
        // you can load your template here;
        // const templateJson = {};
        //  emailEditorRef.current.editor.addEventListener(
        //   'design:loaded',
        //   onDesignLoad
        // );
      
        templateService
        .getEmailTemplateById(clinicId, templateId)
        .then((res) => {
          console.log(res.data);
         
          setTxtType(res.data.type)
          settxtUsedBy(res.data.usedBy)
          setTxtSubject(res.data.subjectLine)
          setJsonString(res.data.jsonContent)
          const jo = JSON.parse(res.data.jsonContent)
          emailEditorRef.current.editor.loadDesign(jo);
        })
        .catch((err) => {
          console.log("Error while getting Eyeconx Template");
        });
      };
    
      const onReady = () => {
        // editor is ready
        console.log('onReady');
      };
  
  const handleCancel = ()=>{
    navigate("/email-template")
  }
  
    return (
   <>  <div className="container container-xxl">
        <nav className="navbar mb-3 navbar-expand-lg rounded p-3" style={{backgroundColor:"#8b02ee"}}>
            <div className="container-fluid">
                        <div className="d-flex flex-column me-4">
                            <span className="navbar-brand" style={{color:"white"}}>Email Template</span>
                            <span className="" style={{color:"white"}}>{txtType && txtType}</span>
                        </div>
                      

                      <div className="d-flex justify-content-between align-items-center flex-grow-1">
                        <label htmlFor="" className="form-label me-2" style={{color:"white"}}>Subject</label>
                        <input type="text" className="form-control" value={txtSubject && txtSubject} onChange={handleTextChange} />
                      </div>
                      <div className='d-flex flex-row align-items-center'>
                     
                      <button className="btn btn-sm btn-warning ms-2" onClick={exportHtml}>Save</button>
                      <button className="btn btn-sm btn-success ms-2" onClick={handleCancel}>Cancel</button>
                      </div>
                    
              
               
            </div>
        </nav>
      
           
            <div className="row">
                <div className="col-12">
                <EmailEditor ref={emailEditorRef} onLoad={onLoad} onReady={onReady} style={{height:"80vh"}} />
                </div>
                {/*<div className="col-4">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Email Template</h4>
                            <span className="card-subtitle">Type : Welcome</span>

                           <div className="form-group">
                                <label htmlFor="" className="form-label">Subject</label>
                                <textarea name="" id="" rows="5" className="form-control"></textarea>
                           </div>
                            <div className="mt-2">
                            <span className="badge text-bg-primary">Primary</span>

                            </div>
                        </div>
                    </div>
    </div> */}
            </div>
        </div>
   </>
  )
}

export default ClinicEditEmailTemplate